import Offcanvas from 'react-bootstrap/Offcanvas';
import { IFulfilment } from '../../../interface/FulfilmentInterface';
import { NairaSymbol } from '../../../utils/mappings';
import { formatDateTime } from '../../../utils/dateTimeUtils';
import { FormEvent, useContext, useState } from 'react';
import { isFormValidated } from '../../../utils/formUtils';
import { endpoints } from '../../../utils/URL';
import axios from 'axios';
import { addToast } from '../../../utils/toastNotifications';
import { AppContext } from '../../../context/AppContext';
import { IApiError, IAppState } from '../../../interface/AppInterface';

const Details = ({
  show,
  close,
  data,
  callback,
}: {
  show: boolean;
  close: Function;
  data?: IFulfilment;
  callback?: Function;
}) => {
  const [pickupCode, setPickupCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { appState }: { appState: IAppState } = useContext(AppContext);

  const axiosInstance = axios.create();

  const verifyCodeAsync = async (event: FormEvent) => {
    if (!isFormValidated('pickup-form')) {
      return;
    }
    event.preventDefault();

    const payload = {
      requestId: `${data?.requestId}`, //data?.requestId,
      pickupCode: pickupCode,
      pharmacyCode: appState.pharmacyCode,
    };

    const url = `${endpoints.fulfilments.mainUrl}/${data?.requestId}/pickupcode`;
    setLoading(true);
    try {
      await axiosInstance.put(url, payload);
      addToast('Medication successfully picked up', 'success');
      setPickupCode('');
      if (callback) {
        callback();
      }
      close();
    } catch (error: any) {
      addToast('An error occured', 'error');
      if (error && error.response) {
        const errorResponse = error.response.data as IApiError;

        if (errorResponse) {
          const detail = errorResponse.detail
            .split('detail')[1]
            .replace(':', '')
            .replace('}', '')
            .replaceAll('"', '');
          addToast(`Error details: ${detail}`, 'error');
        }
      }

      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Offcanvas show={show} onHide={close} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {data && (
              <div>
                {data.patientName} - {data.enrollmentCode}
              </div>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {!data && <div>No fulfilment Selected</div>}
          {data && (
            <div>
              <div className='d-flex justify-content-between mt-2 px-3'>
                <div className=''>Date</div>
                <div className='fw-600'> {formatDateTime(data.dateCreated)}</div>
              </div>
              <div className='d-flex align-items-middle justify-content-between mt-3 px-3'>
                <div className=''>Total Cost</div>
                <div className=''>
                  {NairaSymbol}
                  <span className='fw-600 fs-20'>
                    {data.drugs
                      .reduce((acc, drug) => acc + drug.cost * drug.quantity, 0)
                      .toLocaleString()}
                  </span>
                </div>
              </div>
              {/* If status is approved show input for pickup code */}
              {data.fulfilmentStatus === 'Approved' && (
                <form id='pickup-form' className=''>
                  <fieldset className='d-flex gap-2 px-3 mt-3' disabled={loading}>
                    <input
                      className='form-control'
                      placeholder='Enter Pickup Code'
                      required
                      value={pickupCode}
                      onChange={(e) => setPickupCode(e.target.value)}
                    />
                    <button
                      type='submit'
                      className='btn px-3 btn-primary fs-14'
                      onClick={verifyCodeAsync}
                    >
                      {!loading && <span>Verify</span>}
                      {loading && (
                        <span
                          className='spinner-border spinner-border-sm float-end'
                          role='status'
                          aria-hidden='true'
                        ></span>
                      )}
                    </button>
                  </fieldset>
                </form>
              )}
              {/* Show medication details in a card */}
              <div className='mt-4'>Medications</div>
              {data.drugs.length > 0 &&
                data.drugs.map((drug) => (
                  <div key={drug.drugId} className='card card-shadow'>
                    <div className='card-body p-4'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <div className='card-title fw-600'>
                          <span className='bi bi-capsule me-2'></span>
                          {drug.name}
                        </div>

                        {drug.isDispensed && (
                          <div
                            className='card-title fw-300 fs-14'
                            title={drug.isDispensed ? 'Dispensed' : 'Not Dispensed'}
                          >
                            <span className='bi bi-check-circle-fill text-success fw-900 ms-1'></span>
                          </div>
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-middle mt-1'>
                        {drug.dose ? (
                          <span>{drug.dose}</span>
                        ) : (
                          <span>
                            {drug.strength} {drug.frequency} {drug.duration}
                          </span>
                        )}
                      </div>

                      <div className='d-flex justify-content-between align-items-middle mt-2'>
                        <div className='fw-600 fs-18'>
                          {NairaSymbol}
                          {drug.cost.toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};
export default Details;
